import {
	faAlarmSnooze,
	faAngleLeft,
	faAngleRight,
	faArrowRight,
	faArrowRightFromBracket,
	faArrowsDownToLine,
	faArrowUpFromBracket,
	faArrowUpRightFromSquare,
	faBars,
	faBarsFilter,
	faBatteryBolt,
	faBinary,
	faCalendar,
	faChartLine,
	faCircleCheck,
	faCircleExclamation,
	faCircleInfo,
	faCircleQuestion,
	faCircle as faCircleRegular,
	faClose,
	faCode,
	faCogs,
	faCopy,
	faDash,
	faDiagramProject,
	faDrawPolygon,
	faDroplet as faDropletHollow,
	faEllipsisV,
	faEnvelope,
	faEye,
	faEyeSlash,
	faHotel,
	faKeySkeleton,
	faLightSwitch,
	faMagnifyingGlass,
	faMap,
	faMapLocationDot,
	faMoneyCheckPen,
	faNfcMagnifyingGlass,
	faPenLine,
	faPlusMinus,
	faPowerOff,
	faRotateReverse,
	faSidebar,
	faSignalStream,
	faSimCard,
	faSiren,
	faStar,
	faTable,
	faTemperatureThreeQuarters,
	faTrain,
	faTrashCan,
	faUser,
	faUserGear,
	faUserGroup,
	faUserKey,
	faUserLock,
	faVolume,
	faVolumeXmark,
	faWebhook,
	faWind,
	faXmark,
} from '@awesome.me/kit-a1e2571845/icons/classic/regular'
import {
	faAnchor,
	faArrowDownFromLine,
	faArrowDownToLine,
	faArrowLeft,
	faArrowPointer,
	faArrowUpFromDottedLine,
	faArrowUpFromLine,
	faBackwardStep,
	faBan,
	faBenchTree,
	faBoltLightning,
	faBuilding,
	faBullhorn,
	faCaretDown,
	faCaretRight,
	faCaretUp,
	faChartPie,
	faCheck,
	faChevronDown,
	faChevronsLeft,
	faChevronsRight,
	faChevronUp,
	faCircle,
	faCircleBolt,
	faCircleCheck as faCircleCheckSolid,
	faCircleExclamation as faCircleExclamationSolid,
	faCircleHalfStroke,
	faCircleInfo as faCircleInfoSolid,
	faCircleRadiation,
	faCircleXmark,
	faCloud,
	faCloudBolt,
	faCloudDrizzle,
	faCloudFog,
	faCloudHail,
	faCloudRain,
	faCloudShowersHeavy,
	faCourtSport,
	faDotCircle,
	faDroplet,
	faDropletPercent,
	faEraser,
	faExclamation,
	faFarm,
	faFilter,
	faFire,
	faFlag,
	faFlagCheckered,
	faFog,
	faForwardStep,
	faGear,
	faHelicopter,
	faHelmetSafety,
	faHexagonExclamation,
	faHourglassHalf,
	faIndustry,
	faLayerGroup,
	faLocationCrosshairs,
	faLocationDot,
	faLock,
	faMinus,
	faMinusCircle,
	faMound,
	faPause,
	faPlane,
	faPlaneDeparture,
	faPlay,
	faPlus,
	faQuestion as faQuestionSolid,
	faRaindrops,
	faRepeat,
	faRoad,
	faRoute,
	faRuler,
	faSaltShaker,
	faSatellite,
	faShovel,
	faSignsPost,
	faSmog,
	faSnowflake,
	faSolarPanel,
	faSort,
	faSortDown,
	faSortUp,
	faSpinner,
	faSquare,
	faStar as faStarSolid,
	faSun,
	faSunDust,
	faTemperatureSnow,
	faTowerCell,
	faTransformerBolt,
	faTrees,
	faTriangleExclamation,
	faVectorSquare,
	faVolume as faVolumeSolid,
	faVolumeXmark as faVolumeXmarkSolid,
	faWater,
	faWindTurbine,
	faXmark as faXmarkSolid,
} from '@awesome.me/kit-a1e2571845/icons/classic/solid'
import {
	faSolidSirenSlash,
	faVCrane,
	faVElecLine,
	faVElecTerminal,
	faVHail,
	faVLightningMinus,
	faVLightningPlus,
	faVRepeatSlash,
} from '@awesome.me/kit-a1e2571845/icons/kit/custom'
import { Icon as ThemeIcon } from '@xweather/theme'
import type { ComponentProps } from 'react'

export const Icon = ({ name, ...props }: { name: IconName } & Omit<ComponentProps<typeof ThemeIcon>, 'icon'>) => {
	return <ThemeIcon {...props} icon={supportedIcons[name]} />
}

const supportedIcons = {
	AlarmSnooze: faAlarmSnooze,
	AngleLeft: faAngleLeft,
	AngleRight: faAngleRight,
	Anchor: faAnchor,
	ArrowDownFromLine: faArrowDownFromLine,
	ArrowDownToLine: faArrowDownToLine,
	ArrowLeft: faArrowLeft,
	ArrowPointer: faArrowPointer,
	ArrowRight: faArrowRight,
	ArrowRightFromBracket: faArrowRightFromBracket,
	ArrowsDownToLine: faArrowsDownToLine,
	ArrowUpFromBracket: faArrowUpFromBracket,
	ArrowUpFromDottedLine: faArrowUpFromDottedLine,
	ArrowUpFromLine: faArrowUpFromLine,
	ArrowUpRightFromSquare: faArrowUpRightFromSquare,
	BackwardStep: faBackwardStep,
	Ban: faBan,
	Bars: faBars,
	BarsFilter: faBarsFilter,
	BatteryBolt: faBatteryBolt,
	BenchTree: faBenchTree,
	Binary: faBinary,
	Bullhorn: faBullhorn,
	Building: faBuilding,
	Calendar: faCalendar,
	CaretDown: faCaretDown,
	CaretRight: faCaretRight,
	CaretUp: faCaretUp,
	ChartLine: faChartLine,
	ChartPie: faChartPie,
	Check: faCheck,
	ChevronUp: faChevronUp,
	ChevronDown: faChevronDown,
	ChevronsLeft: faChevronsLeft,
	ChevronsRight: faChevronsRight,
	Circle: faCircle,
	CircleBolt: faCircleBolt,
	CircleCheck: faCircleCheck,
	CircleCheckSolid: faCircleCheckSolid,
	CircleExclamation: faCircleExclamation,
	CircleExclamationSolid: faCircleExclamationSolid,
	CircleHalfStroke: faCircleHalfStroke,
	CircleInfo: faCircleInfo,
	CircleInfoSolid: faCircleInfoSolid,
	CircleQuestion: faCircleQuestion,
	CircleRadiation: faCircleRadiation,
	CircleRegular: faCircleRegular,
	CircleXmark: faCircleXmark,
	Close: faClose,
	Cloud: faCloud,
	CloudBolt: faCloudBolt,
	CloudDrizzle: faCloudDrizzle,
	CloudFog: faCloudFog,
	CloudHail: faCloudHail,
	CloudRain: faCloudRain,
	CloudShowersHeavy: faCloudShowersHeavy,
	Smog: faSmog,
	Snowflake: faSnowflake,
	Sun: faSun,
	SunDust: faSunDust,
	Code: faCode,
	Cogs: faCogs,
	Copy: faCopy,
	CourtSport: faCourtSport,
	Crane: faVCrane,
	Dash: faDash,
	DiagramProject: faDiagramProject,
	DrawPolygon: faDrawPolygon,
	Droplet: faDroplet,
	DropletHollow: faDropletHollow,
	DropletPercent: faDropletPercent,
	EllipsisV: faEllipsisV,
	Envelope: faEnvelope,
	Eraser: faEraser,
	ExclamationMark: faExclamation,
	Eye: faEye,
	EyeSlash: faEyeSlash,
	Farm: faFarm,
	Filter: faFilter,
	Fire: faFire,
	Flag: faFlag,
	FlagCheckered: faFlagCheckered,
	Fog: faFog,
	ForwardStep: faForwardStep,
	Gear: faGear,
	Helicopter: faHelicopter,
	HelmetSafety: faHelmetSafety,
	HexagonExclamation: faHexagonExclamation,
	Hotel: faHotel,
	HourGlassHalf: faHourglassHalf,
	Industry: faIndustry,
	KeySkeleton: faKeySkeleton,
	LayerGroup: faLayerGroup,
	LightningBolt: faBoltLightning,
	LightningPlus: faVLightningPlus,
	LightningMinus: faVLightningMinus,
	LightSwitch: faLightSwitch,
	LocationCrosshairs: faLocationCrosshairs,
	LocationDot: faLocationDot,
	Lock: faLock,
	MagnifyingGlass: faMagnifyingGlass,
	Map: faMap,
	MapLocationDot: faMapLocationDot,
	Minus: faMinus,
	MinusCircle: faMinusCircle,
	MoneyCheckPen: faMoneyCheckPen,
	Mound: faMound,
	NfcMagnifyingGlass: faNfcMagnifyingGlass,
	DotCircle: faDotCircle,
	Pause: faPause,
	PenLine: faPenLine,
	Plane: faPlane,
	PlaneDeparture: faPlaneDeparture,
	Play: faPlay,
	Plus: faPlus,
	PlusMinus: faPlusMinus,
	PowerOff: faPowerOff,
	QuestionSolid: faQuestionSolid,
	Raindrops: faRaindrops,
	Repeat: faRepeat,
	RepeatSlash: faVRepeatSlash,
	Road: faRoad,
	RotateReverse: faRotateReverse,
	Route: faRoute,
	Ruler: faRuler,
	SaltShaker: faSaltShaker,
	Satellite: faSatellite,
	Shovel: faShovel,
	Sidebar: faSidebar,
	SignalStream: faSignalStream,
	SignsPost: faSignsPost,
	SimCard: faSimCard,
	Siren: faSiren,
	SirenSlash: faSolidSirenSlash,
	SolarPanel: faSolarPanel,
	Sort: faSort,
	SortDown: faSortDown,
	SortUp: faSortUp,
	Spinner: faSpinner,
	Star: faStar,
	StarSolid: faStarSolid,
	Stop: faSquare,
	Table: faTable,
	Temperature: faTemperatureThreeQuarters,
	TemperatureSnow: faTemperatureSnow,
	TowerCell: faTowerCell,
	Train: faTrain,
	TransformerBolt: faTransformerBolt,
	Trash: faTrashCan,
	Trees: faTrees,
	TriangleExclamation: faTriangleExclamation,
	User: faUser,
	UserGear: faUserGear,
	UserGroup: faUserGroup,
	UserKey: faUserKey,
	UserLock: faUserLock,
	VCrane: faVCrane,
	VElecLine: faVElecLine,
	VElecTerminal: faVElecTerminal,
	VectorSquare: faVectorSquare,
	VHail: faVHail,
	Volume: faVolume,
	VolumeSolid: faVolumeSolid,
	VolumeXmark: faVolumeXmark,
	VolumeXmarkSolid: faVolumeXmarkSolid,
	Water: faWater,
	Webhook: faWebhook,
	Wind: faWind,
	WindTurbine: faWindTurbine,
	Xmark: faXmark,
	XmarkSolid: faXmarkSolid,
}

export type IconName = keyof typeof supportedIcons
